import React from "react";
import _ from "underscore";

/**
 * A generic tooltip library for React.js
 *
 * Based on Khan Academy's Tooltip component (https://github.com/Khan/react-components/blob/master/js/tooltip.jsx)
 **/

type TTooltipProps = {
    show: boolean;
    height: number;
    /** Required unless horizontalPosition is "left"; used to offset the tooltip leftwards. */
    width?: number;
    className?: string;
    horizontalPosition?: "left" | "right";
    verticalPosition?: "top" | "bottom";
    /** First child is the anchor element; the rest are the tooltip contents. */
    children: React.ReactElement[];
};

const Tooltip = (props: TTooltipProps) => {
    /* A positioned div below the input to be the parent for our
        tooltip */
    const { className = "", horizontalPosition = "left" } = props;
    const isTooltipLeftAligned = horizontalPosition === "left";

    const outerStyle: React.CSSProperties = {
        position: "relative",
    };
    const containerStyle: React.CSSProperties = {
        position: "absolute",
        height: props.height,
        width: "auto",
        overflow: "auto",
        margin: "auto",
        top: 0,
        bottom: 0,
        display: props.show ? "block" : "none",
    };
    if (isTooltipLeftAligned) {
        containerStyle.left = "100%";
    } else {
        const LEFT_PADDING = 15;
        containerStyle.left = `-${(props.width ?? 0) + LEFT_PADDING}px`;
    }
    const tooltipStyle = { height: props.height };

    return (
        <div style={outerStyle}>
            <div className="tooltipContainer" style={containerStyle}>
                {/* The contents of the tooltip */}
                <div className={className} style={tooltipStyle}>
                    {_.rest(props.children)}
                </div>
            </div>
            {/* We wrap our input in a div so that we can put the tooltip in a
                div above/below it */}
            <div>{_.first(props.children)}</div>
        </div>
    );
};

// Sorry.  // Apology-Oriented-Programming
export default Tooltip;
